import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Tooltip } from 'antd';

import { IBrand } from 'entities/Brand';
import { IOffer } from 'entities/Offer';
import { useJoinOffer } from 'entities/Offer/hooks/useJoinOffer';
import { useMedia } from 'shared/hooks';
import { EYmEventsO2, EYmEventsO4 } from 'shared/typings';

interface IJoinButtonProps extends HTMLAttributes<HTMLDivElement> {
	brand?: IBrand;
	offer?: IOffer;
	isBottom?: boolean;
}

export const JoinButton: FC<IJoinButtonProps> = ({ brand, offer, isBottom }) => {
	const { t } = useTranslation();
	const { joinIsDisabled, onJoin } = useJoinOffer(brand, offer);
	const isMd = useMedia();

	if (!brand || !offer) return null;

	return (
		<Tooltip
			title={
				joinIsDisabled
					? t(
							'Вы подали заявку/заявки на все ваши площадки. Чтобы снова подать заявку вам нужно добавить новую площадку.',
						)
					: undefined
			}>
			<Button
				type="primary"
				size={isMd ? 'small' : 'middle'}
				disabled={joinIsDisabled}
				onClick={() => onJoin(EYmEventsO2.PROGRAM_DETAILS, isBottom ? EYmEventsO4.BOTTOM : EYmEventsO4.HEADER)}>
				{t('Подать заявку')}
			</Button>
		</Tooltip>
	);
};
